<template>
  <div>
    <div :class="styles">
      <ValidationProvider
        :name="fieldName"
        :rules="validationRules"
        v-slot="{ errors }"
      >
        <b-field>
          <template #label
            >{{ label
            }}<span v-if="required" class="has-text-danger">*</span></template
          >

          <b-input
            v-model="vModelVaribale"
            :type="type ? type : `text`"
            :disabled="disabled"
            :readonly="readonly"
            :maxlength="maxLength ? maxLength : ``"
            @input="componentFunctionOne"
          ></b-input>
        </b-field>
        <span class="has-text-danger">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
  </div>
</template>
<script>
export default {
  name: "InputLabel",

  props: [
    "label",
    "value",
    "styles",
    "inputFunc",
    "type",
    "maxLength",
    "validationRules",
    "fieldName",
    "disabled",
    "readonly",
    "required",
    "componentFunctionOne",
  ],

  components: {},
  data() {
    return {
      errorFromProvider: "",
    };
  },
  methods: {
    sendError(error) {
      this.$emit(`getError`, error);
    },
  },
  computed: {
    vModelVaribale: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
<style></style>
